module.exports = __webpack_public_path__ + "f127fbd4b523931e1a3a75c80ca238fc.svg";